import { memo } from "react"
import { FeedCurve } from "../../../../Services"
import { frames } from "../../../../Styles"
import { useFeedCurveContext } from "../../../FeedCurves/_FeedCurves/feedCurveContext";

const LabelsComponents = memo(({ feedCurve }: { feedCurve: FeedCurve }) => {
  const context = useFeedCurveContext();  
  const selectedComponent = context?.state?.component;
  const dispatch = context?.dispatch;

  if (feedCurve?.components === undefined) return null;

  return (
    <div style={{display: "flex", flexDirection: "column", alignItems: "center", gap: "5px", width: "fit-content"}}>
      {feedCurve?.components?.map((feedcurveComponent, index) => {
        const _isHovered = selectedComponent === feedcurveComponent.componentId;
        
        return (
        <frames.Label
          key={feedcurveComponent.componentId}
          $isHovered={_isHovered}
          $component={feedcurveComponent}
          onMouseEnter={() => dispatch({ component: feedcurveComponent.componentId })}
          onMouseLeave={() => dispatch({ component: undefined })}
        >
          {feedcurveComponent.name}
        </frames.Label>
      )})}
    </div>
  )
})

export default LabelsComponents